// ABOUTME: Search dialog hook using global dialog store
// ABOUTME: Manages search dialog state and scroll offset for virtual keyboard

import { useState } from "react";

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "search";

export function useSearchDialog() {
  const { isOpen, open: openDialog, close } = useGlobalDialogs();
  const [scrollOffset, setScrollOffset] = useState(0);

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: () => openDialog(DIALOG_ID),
    close,
    scrollOffset,
    setScrollOffset,
  };
}
